import { render } from "./App.vue?vue&type=template&id=0bbc929a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0bbc929a&lang=css"

import exportComponent from "C:\\Users\\28950\\source\\repos\\xtz\\hql\\bm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__